import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminPricing = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin/settings?tab=pricing', { replace: true });
  }, [navigate]);
  return null;
};

export default AdminPricing;
